var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChoose = function SvgChoose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "choose_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6444"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3h18v18H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#choose_svg__a)",
    fillRule: "nonzero",
    d: "M9 0a9 9 0 1 1-.001 18.001A9 9 0 0 1 9 0zm0 .72a8.28 8.28 0 1 0 0 16.56A8.28 8.28 0 0 0 9 .72zm4.928 4.584a.36.36 0 0 1 .04.46l-.041.05-6.631 6.602a.36.36 0 0 1-.466.036l-.05-.044-2.758-2.916a.36.36 0 0 1 .475-.538l.049.043 2.503 2.648 6.37-6.342a.36.36 0 0 1 .509.001z",
    transform: "translate(3 3)"
  }))));
};

export { SvgChoose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iMCUiIHgyPSIxMDAlIiB5MT0iMTAwJSIgeTI9IjAlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjRkY0NDRGIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjRkY2NDQ0Ii8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMyAzaDE4djE4SDN6Ii8+PHBhdGggZmlsbD0idXJsKCNhKSIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNOSAwYTkgOSAwIDExLS4wMDEgMTguMDAxQTkgOSAwIDAxOSAwem0wIC43MmE4LjI4IDguMjggMCAxMDAgMTYuNTZBOC4yOCA4LjI4IDAgMDA5IC43MnptNC45MjggNC41ODRhLjM2LjM2IDAgMDEuMDQuNDZsLS4wNDEuMDUtNi42MzEgNi42MDJhLjM2LjM2IDAgMDEtLjQ2Ni4wMzZsLS4wNS0uMDQ0LTIuNzU4LTIuOTE2YS4zNi4zNiAwIDAxLjQ3NS0uNTM4bC4wNDkuMDQzIDIuNTAzIDIuNjQ4IDYuMzctNi4zNDJhLjM2LjM2IDAgMDEuNTA5LjAwMXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiLz48L2c+PC9zdmc+Cg==";